import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Navbar from "../components/Navbar";
import { fetchVideoUrl } from "../utils/Api";

const Video = () => {
  const { jobId } = useParams();
  const navigate = useNavigate();
  const [videoSrc, setVideoSrc] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadVideo = async () => {
      try {
        const data = await fetchVideoUrl(jobId);
        setVideoSrc(data.video_url);
      } catch (err) {
        console.error("Error fetching video:", err);
        setError("Video is no longer available.");
      } finally {
        setLoading(false);
      }
    };

    loadVideo();
  }, [jobId]);

  const goToResults = () => {
    navigate("/results");
  };

  return (
    <div>
      <Navbar />
      <div className="video-page-container">
        <h1 className="video-title">
          Video <span className="green-text">player</span>
        </h1>
        <div className="video-container">
          {loading && <div className="spinner"></div>}
          {error && <p className="video-error">{error}</p>}
          {videoSrc && (
            <video className="video-player" controls>
              <source src={videoSrc} />
            </video>
          )}
        </div>
      </div>
      <div className="footer-container">
        <div className="footer-left">
          <a onClick={goToResults} className="nav-link">
            Back
          </a>
        </div>
      </div>
    </div>
  );
};

export default Video;
